import { render, staticRenderFns } from "./BankExtractImportsPage.vue?vue&type=template&id=0f78317e&"
import script from "./BankExtractImportsPage.vue?vue&type=script&lang=ts&"
export * from "./BankExtractImportsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
